import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../../../../core/services/auth.service';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import { FileElement } from '../../../secure/instruction-docs/share/fileElement.model';

@Injectable()
export class HelpDocsService {
  constructor(
    private httpClient: HttpClient,
    private authService: AuthService,
  ) {}

  get(): Observable<FileElement[]> {
    const headers = this.authService.getBearerRequestHeaders();
    return this.httpClient.get<FileElement[]>(`${environment.helpDocsUrl}`, {
      headers,
    });
  }

  getFileBy(document: FileElement): Observable<Blob | string> {
    const headers = this.authService.getBearerRequestHeaders();

    return this.httpClient.get(
      `${environment.helpDocsUrl}/file/${document.parent}/${document.name}`,
      {
        headers,
        responseType: 'blob',
      },
    );
  }
}
